(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBundleSlider(sectionElement) {
      if (!sectionElement || sectionElement.dataset.bundleSwiperInit === 'true') {
        return;
      }

      const mainNode = sectionElement.querySelector('[data-bundle-main-swiper]');
      const thumbsNode = sectionElement.querySelector('[data-bundle-thumbs-swiper]');
      if (!mainNode || !thumbsNode || !window.Swiper) {
        return;
      }

      const thumbSlides = thumbsNode.querySelectorAll('.swiper-slide');
      const thumbCount = thumbSlides.length;
      const visibleThumbCount = Math.max(thumbCount - 1, 1);
      const thumbsPerView = Math.min(visibleThumbCount, 4);

      const thumbsSwiper = new window.Swiper(thumbsNode, {
        spaceBetween: 14,
        slidesPerView: thumbsPerView,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          0: { slidesPerView: thumbsPerView, spaceBetween: 10 },
          576: { slidesPerView: thumbsPerView, spaceBetween: 12 },
          990: { slidesPerView: thumbsPerView, spaceBetween: 14 },
        },
      });

      function hideActiveThumb(activeIndex) {
        thumbSlides.forEach(function (slide, index) {
          const isActive = index === activeIndex;
          slide.classList.toggle('lp-bundle_thumb--hidden', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'true' : 'false');
        });
        thumbsSwiper.update();
        thumbsSwiper.updateSlides();
        thumbsSwiper.updateSize();
      }

      const mainSwiper = new window.Swiper(mainNode, {
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 550,
        effect: 'slide',
        autoHeight: true,
        thumbs: {
          swiper: thumbsSwiper,
        },
        on: {
          init: function () {
            hideActiveThumb(this.activeIndex);
          },
          slideChange: function () {
            hideActiveThumb(this.activeIndex);
          },
        },
      });

      hideActiveThumb(mainSwiper.activeIndex);

      sectionElement.dataset.bundleSwiperInit = 'true';
    }

    function waitForSwiperAndInit(sectionElement, retries) {
      if (window.Swiper) {
        initBundleSlider(sectionElement);
        return;
      }

      if (retries <= 0) {
        return;
      }

      window.setTimeout(function () {
        waitForSwiperAndInit(sectionElement, retries - 1);
      }, 100);
    }

    function initAllBundleSections(scope) {
      const root = scope || document;
      const sections = root.querySelectorAll('.lp-bundle');
      sections.forEach(function (sectionElement) {
        waitForSwiperAndInit(sectionElement, 80);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllBundleSections(document);
      });
    } else {
      initAllBundleSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAllBundleSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let ReviewSwiper = null;

    function initReviewSwiper() {
      if (ReviewSwiper) {
        ReviewSwiper.destroy(true, true);
        ReviewSwiper = null;
      }

      ReviewSwiper = new Swiper('.reviews-swiper', {
        pagination: {
          el: '.reviews-swiper .swiper-pagination',
          type: 'progressbar',
          clickable: false,
        },
        spaceBetween: 16,
        navigation: {
          nextEl: '.reviews-swiper .swiper-button-next',
          prevEl: '.reviews-swiper .swiper-button-prev',
        },
        mousewheel: true,
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            mousewheel: false,
          },
          768: {
            slidesPerView: 1,
          },
          991: {
            slidesPerView: 2,
          },
          1200:{
            slidesPerView: 2.4,
          },
        },
      });

      // Toggle visibility of navigation and pagination
          }

    initReviewSwiper();
    window.addEventListener('resize', initReviewSwiper);
  });

  } catch(e) { console.error(e); }
})();
})();
